<template>
  <div class="toolbar-container no-print">
    <div class="toolbar is-flex" :class="{'fixed-header': makeFixed}">
      <div v-if="!isView" class="story-type cursor-pointer unselectable" @click="seenTypeDropdown = !seenTypeDropdown">
        <div class="dropdown" :class="{'is-active' : seenTypeDropdown}">
          <div class="dropdown-trigger">
            {{ selectedType }} <span class="icon is-small"><i class="fal fa-angle-down" aria-hidden="true"></i></span>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a href="#" @click="$emit('updateStoryType', type), selectedType = type" v-for="type in storyTypes" :key="type" class="dropdown-item">
                {{ type }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isView" class="story-type unselectable">
        {{ storyType }}
      </div>
      <!-- All Buttons -->
      <div v-if="!showDatePicker" class="all-buttons controls is-flex">
          <span v-for='button in buttons' :key="button.name" @click="click(button.name)" :class="[buttonClasses, button.classes, {'is-loading': saving && clicked === button.name}]" :disabled="saving && clicked!==button.name" v-html="button.content"
            :data-balloon="button.balloon" data-balloon-pos="down">
          </span>
      </div>
      <!-- <datepicker class="datepicker" placeholder="Publish" :format="format" v-model="publishDate"></datepicker> -->
      <datepicker :showDatePicker="showDatePicker" @publish="emitSave"></datepicker>
    </div>
    <div v-if="saveMessage && saveMessage.length" class="alert-bar has-text-white is-flex" :class="{'alert-bar-fixed' : makeFixed, 'has-background-primary' : saveMessage == 'Saved', 'has-background-danger' : saveMessage != 'Saved'}">
      <div> {{ saveMessage }} </div><span class="close" @click="clearMessage"><i class="fal fa-times cursor-pointer"></i></span>
    </div>
    <modal-custom v-if="seenModal" :title="modal.title" :text="modal.text" :successText="modal.successText" :cancelText="$t('cancel')"
      @modalSuccess="modalSuccess" :hasClose="true" :hasFooter="true" @modalCancel="seenModal = false" @modalClose="seenModal = false">
    </modal-custom>
  </div>
</template>

<script>

import ModalCustom from '@/components/Modals/Custom'
import Datepicker from './DateDropdown'
// import Datepicker from 'vuejs-datepicker'

// Buttons
const buttonClasses = ['button', 'is-small', 'is-rounded']
const trashCan = '<span><i class="fal fa-trash"></i></span>'
const cancelContent = '<span class="is-hidden-tablet"><i class="fal fa-times"></i></span> <span class="is-hidden-mobile">Cancel</span>'

const deleteButton = {
  name: 'del',
  classes: ['is-outlined', 'is-grey-light'],
  content: trashCan,
  balloon: 'Delete'
}
const cancel = {
  name: 'cancel',
  classes: ['is-outlined', 'is-danger'],
  content: cancelContent
}
const saveDraft = {
  name: 'saveDraft',
  classes: ['is-outlined', 'is-primary'],
  content: 'Save Draft'
}
const preview = {
  name: 'preview',
  classes: ['is-outlined', 'is-primary'],
  content: 'Preview'
}
const publish = {
  name: 'publish',
  classes: ['is-primary'],
  content: 'Publish'
}
const unpublish = {
  name: 'unpublish',
  classes: ['is-outlined', 'is-primary'],
  content: 'Unpublish'
}
const republish = {
  name: 'republish',
  classes: ['is-primary'],
  content: 'Republish'
}
const edit = {
  name: 'edit',
  classes: ['is-outlined', 'is-primary'],
  content: 'Edit'
}

export default {
  components: {
    Datepicker,
    ModalCustom
  },
  props: ['project', 'saving', 'isView', 'saveMessage', 'firstSave'],
  mixins: [],
  data: function () {
    return {
      storyTypes: [this.$t('createEdit.storyTypes.curated'), this.$t('createEdit.storyTypes.anchor'), this.$t('createEdit.storyTypes.featured'), this.$t('createEdit.storyTypes.sponsored')],
      deleteModal: [{
        title: this.$t('createEdit.modals.delete.title'),
        text: this.$t('createEdit.modals.delete.text'),
        successText: this.$t('createEdit.modals.delete.successText')
      }],
      unpublishModal: [{
        title: this.$t('createEdit.modals.unpublish.title'),
        text: this.$t('createEdit.modals.unpublish.text'),
        successText: this.$t('createEdit.modals.unpublish.successText')
      }],
      seenTypeDropdown: false,
      seenModal: false,
      selectedType: this.$t('createEdit.modals.storyType'),
      scrollTop: 0,
      modal: {},
      modalSuccess: null,
      clicked: '',
      buttonClasses,
      publishDate: '',
      format: 'yyyy-MM-dd',
      showDatePicker: false
    }
  },
  created: function () {
    this.attachScrollListener()
  },
  destroyed: function () {
    this.detachScrollListener()
  },
  computed: {
    storyType: function () {
      return this.project ? this.project.storyType : this.selectedType
    },
    isPrivate: function () {
      return this.project ? this.project.isPrivate : true
    },
    makeFixed: function () {
      return this.scrollTop > 8
    },
    isCreated: function () {
      return this.project && this.project.id > 0
    },
    createMode: function () {
      return !this.isView && this.isPrivate
    },
    editMode: function () {
      return !this.isView && !this.isPrivate
    },
    viewMode: function () {
      return this.isView
    },
    buttons: function () {
      let buttonList = []
      // Create
      if (this.createMode) {
        buttonList = this.project ? [cancel, saveDraft, preview, publish] : [deleteButton, saveDraft, preview, publish]
      }
      // Edit
      if (this.editMode) {
        buttonList = [deleteButton, cancel, unpublish, republish]
      }
      // View
      if (this.viewMode) {
        buttonList = this.isPrivate ? [edit, publish] : [edit]
      }
      return buttonList
    }
  },
  methods: {
    clearMessage: function () {
      this.message = ''
      this.$emit('clearMessage')
    },
    click: function (type) {
      if (this.saving) {
        return
      }
      this.clicked = type

      switch (type) {
        case 'del':
          this.handleModal('del')
          return
        case 'cancel':
          this.project ? this.$router.push({ name: 'viewStory', params: { id: this.project.id } }) : this.$router.go(-1)
          return
        case 'saveDraft':
          this.$emit('save', true, false)
          return
        case 'preview':
          this.$emit('save', true, true)
          return
        case 'publish':
          this.showDatePicker = !this.showDatePicker
          return
        case 'unpublish':
          this.handleModal('unpublish')
          return
        case 'republish':
          this.$emit('save', false, true)
          return
        case 'edit':
          this.editProject()
      }
    },
    unpublish: function () {
      this.seenModal = false
      this.$emit('unpublish')
    },
    del: function () {
      this.seenModal = false
      this.$emit('del')
    },
    editProject: function () {
      this.$router.push({ name: 'create', params: { id: this.project.id } })
    },
    checkFixedHeader: function () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.scrollTop = scrollTop
    },
    attachScrollListener: function () {
      window.addEventListener('scroll', this.checkFixedHeader)
    },
    detachScrollListener: function () {
      window.removeEventListener('scroll', this.checkFixedHeader)
    },
    handleModal: function (type) {
      switch (type) {
        case 'reset':
          this.seenModal = false
          return
        case 'del':
          this.modal = this.deleteModal
          this.seenModal = true
          this.modalSuccess = this.del
          return
        case 'unpublish':
          this.modal = this.unpublishModal
          this.seenModal = true
          this.modalSuccess = this.unpublish
      }
    },
    emitSave: function (isPrivate, dateTime) {
      this.showDatePicker = false
      this.$emit('save', isPrivate, true, dateTime)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .toolbar-container {
    position: relative;
    width: 100%;
    height: 40px;
    border-top: 0.5rem solid whitesmoke;
  }
  .toolbar {
    box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.10);
    width: 700px; // content-area
    background-color: $white;
    height: inherit;
    position: relative;
    z-index: 5;
    padding: 0.3rem 0.5rem;
    align-items: center;
    justify-content: space-between;
    .button {
      margin: 0 0.2rem;
      @include mobile {
        margin: 0 0.1rem;
        font-size: 0.7rem;
      }
    }
    @include mobile {
      width: 100%;
      padding: 0.1rem;
    }
  }
  .fixed-header {
    position: fixed;
    top: 52px; // account for the nav
  }
  .editor-buttons {
    flex: 1;
  }
  .story-type {
    font-size: 0.75rem;
  }
  .controls {
    justify-content: space-between;
    .trash-can {
      color: darkgrey;
      padding-right: 0.2rem;
    }
  }
  .alert-bar {
    width: 700px;
    top: calc(40px + 52px + 0.5rem); // publishtoolbar height + nav height + top spacing
    z-index: 5;
    justify-content: center;
    align-items: center;
    position: fixed;
    .close {
      position: absolute;
      right: 1rem;
    }
  }
  .alert-bar-fixed {
    top: calc(40px + 52px); // publishtoolbar height + nav height
  }

  .date-picker {
    z-index: 5;
  }
</style>
